<template>
	<div class="content-wrapper table-responsive">
		<lead-profile-card ref="leadProfileCard" :leadId="id" />

		<div class="mb-primary" v-if="(logPropsData || basicInfoPropsData || marketingPropsData || placementPropsData || schedulePropsData || financePropsData || vanumberPropsData || invoiceApprovalPropsData) && proccesTab > 0">
			<div class="card p-primary border-0">
				<lead-profile-form-wizard :tabs="computedTabs" :proccesTab="proccesTab" @parent-interview-updated="onParentInterviewUpdated"/>
			</div>
		</div>
	</div>
</template>

<script>
const LeadProfileLog = () => import("./Tabs/Log/Log.vue");
const LeadProfileBasicInfo = () => import("./Tabs/BasicInfo/BasicInfo.vue"); 
const LeadProfileParentInterview = () => import("./Tabs/ParentInterview/ParentInterview.vue");
// const LeadProfileLanguage = () => import("./Tabs/Language/Language.vue");
// const LeadProfilePersonal = () => import("./Tabs/Personal/Personal.vue");
const LeadProfileMarketing = () => import("./Tabs/Marketing/Marketing.vue");
const LeadProfilePlacement = () => import("./Tabs/Placement/Placement.vue");
// const LeadProfileSchedule = () => import("./Tabs/Schedule/Schedule.vue");
const LeadProfileFinance = () => import("./Tabs/Invoice/InvoiceHistory.vue");
const LeadProfileVaNumber = () => import("./Tabs/VaNumber/VaNumber.vue");
const LeadProfileInvoiceApproval = () => import("./Tabs/InvoiceApproval/InvoiceApproval.vue");
// const LeadProfileFinance = () => import("./Tabs/Finance/Finance.vue");
 
export default {
	name: "LeadProfile", 
	data() {
		return {
			id: null,
			proccesTab: 0,
			logPropsData: null,
			basicInfoPropsData: null,
			parentInterviewPropsData: null,
			// languagePropsData: null,
			personalPropsData: null,
			marketingPropsData: null,
			placementPropsData: null,
			schedulePropsData: null,
			financePropsData: null,
			vanumberPropsData: null,
			invoiceApprovalPropsData: null,
			leadProfileTabs: [
							// AKTIF
				{
					icon: "",
					name: "log",
					component: LeadProfileLog,
					permission: this.$can('view_list_lead_leadprofile_tab_log'),
					class: ""
				},
				{
					icon: "",
					name: "lead info",
					component: LeadProfileBasicInfo,
					permission: this.$can('view_list_lead_leadprofile_tab_basicinfo'),
					class: "",
				},
				{
					icon: "",
					name: "parent interview",
					component: LeadProfileParentInterview,
					permission: this.$can('view_list_lead_leadprofile_tab_parentinterview'),
					class: "",
				},
							// END AKTIF
				// {
				// 	icon: "",
				// 	name: "info",
				// 	component: "lead-profile-tab-info",
				// 	permission: "",
				// 	class: "",
				// },
				// {
				// 	icon: "",
				// 	name: "school",
				// 	component: "lead-profile-tab-school",
				// 	permission: "",
				// 	class: "",
				// },
							// AKTIF
				// {
				// 	icon: "",
				// 	name: "language",
				// 	component: LeadProfileLanguage,
				// 	permission: this.$can('view_list_lead_leadprofile_tab_language'),
				// 	class: "",
				// },
				// {
				// 	icon: "",
				// 	name: "personal",
				// 	component: LeadProfilePersonal,
				// 	permission: this.$can('view_list_lead_leadprofile_tab_personal'),
				// 	class: "",
				// },
				{
					icon: "",
					name: "marketing",
					component: LeadProfileMarketing,
					permission: this.$can('view_list_lead_leadprofile_tab_marketing'),
					class: "",
				},
				{
					icon: "",
					name: "booking",
					component: LeadProfilePlacement,
					permission: this.$can('view_list_lead_leadprofile_tab_placement'),
					class: "",
				},
				// {
				// 	icon: "",
				// 	name: "schedule",
				// 	component: LeadProfileSchedule,
				// 	permission: this.$can('view_list_lead_leadprofile_tab_schedule'),
				// 	class: "",
				// },
				{
					icon: "",
					name: "invoice approval",
					component: LeadProfileInvoiceApproval,
					permission: this.$can('view_list_lead_leadprofile_tab_invoice_approval'),
					class: "",
				},
				{
					icon: "",
					name: "finance",
					component: LeadProfileFinance,
					permission: this.$can('view_list_lead_leadprofile_tab_finance'),
					class: "",
				},
				{
					icon: "",
					name: "VA Number",
					component: LeadProfileVaNumber,
					permission: this.$can('view_list_lead_leadprofile_tab_va_number'),
					class: "",
				},
							// END AKTIF
				// {
				// 	icon: "",
				// 	name: "class",
				// 	component: "lead-profile-tab-class",
				// 	permission: "",
				// 	class: "",
				// },
			],
		};
	},
	created() {
		let url = window.location.href;
		this.id = url.split("/").slice(-1)[0].split("?")[0];
		this.fetchData();
	},
	computed: {
		computedTabs() {
			return this.leadProfileTabs.map((tab) => {
				if (tab.name === "log") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.logPropsData,
						},
					};
				}
				if (tab.name === "lead info") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.basicInfoPropsData,
						},
					};
				}
				if (tab.name === "parent interview") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.parentInterviewPropsData,
						},
					};
				}
				// if (tab.name === "language") {
				// 	return {
				// 		...tab,
				// 		props: {
				// 			...tab.props,
				// 			value: this.languagePropsData,
				// 		},
				// 	};
				// }
				// if (tab.name === "personal") {
				// 	return {
				// 		...tab,
				// 		props: {
				// 			...tab.props,
				// 			value: this.personalPropsData,
				// 		},
				// 	};
				// }
				if (tab.name === "marketing") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.marketingPropsData,
						},
					};
				}
				if (tab.name === "booking") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.placementPropsData,
						},
					};
				}
				// if (tab.name === "schedule") {
				// 	return {
				// 		...tab,
				// 		props: {
				// 			...tab.props,
				// 			value: this.schedulePropsData,
				// 		},
				// 	};
				// }
				if (tab.name === "invoice approval") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.invoiceApprovalPropsData,
						},
					};
				}
				if (tab.name === "finance") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.financePropsData,
						},
					};
				}
				if (tab.name === 'VA Number') {
					return {
						... tab,
						props: {
							... tab.props,
							value: this.vanumberPropsData
						}
					}
				}
				return tab;
			});
		},
	},
	methods: {
		onParentInterviewUpdated() {
			this.$refs.leadProfileCard.refreshCardData();

			this.fetchData();
		},
		async fetchData() {
			try {
				const userResponse = await axios.get(
					"/transaction/lead/" + this.id
				);

				const InvoiceApproval = await axios.get(
					"/transaction/assign-schedule?clc_id_number=" + userResponse.data.clc_id_number
				);

				const Finance = await axios.get(
					"/transaction/invoice-v2?clc_id_number=" + userResponse.data.clc_id_number
				);

				const financeData = Finance.data?.data || [];
				const allowedFinanceStatus = [
					"Waiting Approval Finance",
					"Processed",
					"Paid",
					"UnPaid",
					"Invoiced",
					"Voided",
				];

				const hasFinanceMatch = financeData.some(item =>
					allowedFinanceStatus.includes(item.status)
				);
				
				if(userResponse.data.parent_interview_status == 0){
					this.proccesTab = 4;
				}else if (hasFinanceMatch) {
					this.proccesTab = 10;
				}else if ( InvoiceApproval.data.data.length > 0) {
					this.proccesTab = 6;
				}else if(userResponse.data.parent_interview_status == 1){
					this.proccesTab = 5;
				}
		
				// assign data to logPropsData
				this.logPropsData = userResponse.data;

				// assign data to basicInfoPropsData
				this.basicInfoPropsData = userResponse.data;
				this.parentInterviewPropsData = userResponse.data;

				// assign data to languagePropsData
				// this.languagePropsData = userResponse.data;

				// assign data to personalPropsData
				// this.personalPropsData = userResponse.data;

				// assign data to marketingPropsData
				this.marketingPropsData = userResponse.data;

				// assign data to placementPropsData
				this.placementPropsData = userResponse.data;

				// assign data to schedulePropsData
				// this.schedulePropsData = userResponse.data;

				// assign data to financePropsData
				this.invoiceApprovalPropsData = userResponse.data;
				this.financePropsData = userResponse.data;
				this.vanumberPropsData = userResponse.data;

			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
	},
};
</script>

<style scoped>
.card {
	box-shadow: 0 10px 12px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
.content-wrapper {
  margin-bottom: 200px; /* Adjust the margin value as needed */
  height: 90vh;
  padding-top: 0;
}
</style>
